<template>
  <div>
    <div class="activate4_box">
      <div class="list_box">
        <div class="title_box">
          <div class="contract_type">{{ $t('open_position') }}</div>
          <div class="contract_level" @click="openLevel(1)">{{ levelOpen }}x</div>
        </div>
        <div class="titile">
          <div :class="'t_item '+(openMarketType==0?'active':'')" @click="openMarketType=0">{{$t('limit_order')}}</div>
          <div :class="'t_item '+(openMarketType==1?'active':'')" style="margin-left: 24px" @click="openMarketType=1">
            {{$t('market_order')}}
          </div>
        </div>
        <div class="top_box">
          <div class="jyd">
            <span>{{ $t('trading_pair') }}</span>
            <el-select class="jyd_select select_down" v-model="openValue" popper-class="custom-select-dropdown">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="price">
            <span>{{ $t('current_price') }}</span>
            <span class="nu">{{ currentOpenPrice }}</span>
          </div>
        </div>
        <div class="ttt2">{{ $t('order_price') }}</div>
        <div class="order_price_box" v-if="openMarketType==0" v-click-outside="closeModal">
          <span class="ttt">{{ $t('order_price') }}</span>
          <el-input v-model="openPrice" :placeholder="$t('enter_content')"></el-input>
          <span class="new" style="cursor: pointer" @click="updateLimitPrice(1)">|&nbsp;&nbsp;{{ $t('latest') }}</span>
          <span style="cursor: pointer" @click="openModal">
            <span>+</span>
            <span>/</span>
            <span>-</span>
          </span>
          <div class="grid_box" v-if="showModal">
            <div class="grid_list" style="font-size: 20px">+</div>
            <div class="grid_list" style="font-size: 20px">-</div>
            <div class="grid_list" @click="add(1,5)">+5</div>
            <div class="grid_list" @click="add(1,-5)">-5</div>
            <div class="grid_list" @click="add(1,20)">+20</div>
            <div class="grid_list" @click="add(1,-20)">-20</div>
            <div class="grid_list" @click="clearPrice(1)">C</div>
            <div class="grid_list" @click="returnPrice(1)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                   stroke="currentColor" class="w-6 h-6 inline-block">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"/>
              </svg>
            </div>
          </div>
        </div>

        <div class="order_price_box" v-if="openMarketType==1" style="background: #26282C;">
          <span class="ttt">{{ $t("order_price") }}</span>
          <div style="flex: 1;"></div>
          <span class="new">{{ $t("market_order") }}</span>
        </div>

        <div class="ttt2">{{ $t("order_quantity") }}</div>
        <div class="order_price_box">
          <span class="ttt">{{ $t('order_quantity') }}</span>
          <el-input v-model="openNum" :placeholder="$t('enter_content')" @focus="clear(1)"></el-input>
          <span :class="'new '" style="white-space: nowrap;cursor: pointer;width: revert"
                @click="setOpenMax">|&nbsp;&nbsp;{{ $t('maximum_value') }}</span>
        </div>
        <draggable-progress v-model="progressOpen" :content="['0','100%']"/>
        <div class="list" style="margin-top: 44px">
          <div class="left line"><span>{{ $t("max_openable") }}</span></div>
          <div class="right line">
            {{
              maxOpen
            }}<span
              style="margin-left: 10px;color:#A6A6A6">{{ openValue }}</span></div>
        </div>
        <div :class="'list'" style="margin-top: 14px">
          <div class="left line">
            <span>{{ $t("margin") }}</span>
          </div>
          <div class="right line">{{ marginLimit }}<span
              style="margin-left: 10px;color:#A6A6A6">{{ tableData4[0].coin }}</span></div>
        </div>

        <div class="btn_box">
          <div class="btnm" @click="open(1,true)" style="margin-right: 10px">
            {{ $t('long_position') }}
          </div>
          <div class="btnm" @click="open(1,false)" style="margin-left:10px;background: rgba(239, 69, 74, 1);">
            {{ $t('short_position') }}
          </div>
        </div>
      </div>
      <div class="list_box">
        <div class="title_box">
          <div class="contract_type">{{ $t('close_position') }}</div>
          <div class="contract_level" @click="openLevel(2)">{{ levelClose }}x</div>
        </div>
        <div class="titile">
          <div :class="'t_item '+(closeMarketType==0?'active':'')" @click="closeMarketType=0">{{$t('limit_order')}}</div>
          <div :class="'t_item '+(closeMarketType==1?'active':'')" style="margin-left: 24px" @click="closeMarketType=1">
            {{$t('market_order')}}
          </div>
          <div :class="'t_item '+(closeMarketType==2?'active':'')" style="margin-left: 24px" @click="closeMarketType=2">
            {{$t('take_profit_stop_loss')}}
          </div>
        </div>
        <div class="top_box">
          <div class="jyd">
            <span>{{ $t('trading_pair') }}</span>
            <el-select v-model="closeValue" class="jyd_select select_down" popper-class="custom-select-dropdown">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="price">
            <span>{{ $t('current_price') }}</span>
            <span class="nu">
              {{ currentPrice }}
            </span>
          </div>

          <div v-if="closeMarketType==2">
            <span class="direct_title">{{$t('one_side')}}/{{$t('both_sides')}}</span>
            <el-select v-model="directValue" class="jyd_select select_down direct_select"
                       popper-class="custom-select-dropdown">
              <el-option v-for="item in directValues" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>

        </div>
        <div class="ttt2">{{ $t("order_price") }}</div>

        <div class="order_price_box" v-if="closeMarketType==0" v-click-outside="closeModal">
          <span class="ttt">{{ $t('order_price') }}</span>
          <el-input v-model="closePrice" :placeholder="$t('enter_content')"></el-input>
          <span class="new" style="cursor: pointer" @click="updateLimitPrice(2)">|&nbsp;&nbsp;{{ $t('latest') }}</span>
          <span style="cursor: pointer" @click="openModal">
            <span>+</span>
            <span>/</span>
            <span>-</span>
          </span>
          <div class="grid_box" v-if="showModal">
            <div class="grid_list" style="font-size: 20px">+</div>
            <div class="grid_list" style="font-size: 20px">-</div>
            <div class="grid_list" @click="add(2,5)">+5</div>
            <div class="grid_list" @click="add(2,-5)">-5</div>
            <div class="grid_list" @click="add(2,20)">+20</div>
            <div class="grid_list" @click="add(2,-20)">-20</div>
            <div class="grid_list" @click="clearPrice(2)">C</div>
            <div class="grid_list" @click="returnPrice(2)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                   stroke="currentColor" class="w-6 h-6 inline-block">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"/>
              </svg>
            </div>
          </div>
        </div>

        <div class="order_price_box" v-if="closeMarketType==1" style="background: #26282C;">
          <span class="ttt">{{ $t("order_price") }}</span>
          <div style="flex: 1;"></div>
          <span class="new">{{ $t("market_order") }}</span>
        </div>


        <div class="order_price_box2" v-if="closeMarketType==2 && directValue==1">
          <div class="direct_price" style="margin-top: 7px;">
            <span class="target_price_title">{{$t('trigger_price')}}</span>
            <el-input class="direct_input" v-model="targetPrice" style="margin-top: 6px;"/>
          </div>
          <div class="direct_price">
            <el-select v-model="targetType" class="jyd_select select_down target_select"
                       popper-class="custom-select-dropdown">
              <el-option v-for="item in targetTypes" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input class="direct_input" v-model="targetLimitPrice" v-if="targetType==2"/>
            <div class="target_price_market" v-if="targetType==1" style="background: #26282C;">
              <span class="new">{{ $t("market_order") }}</span>
            </div>
          </div>
        </div>

        <div class="order_price_box2" v-if="closeMarketType==2 && directValue==2">
          <div class="direct_price" style="margin-top: 7px">
            <span class="target_price_title">{{$t('take_profit_trigger_price')}}</span>
            <el-input class="direct_input" v-model="targetWinPrice" style="margin-top: 6px;"/>
          </div>
          <div class="direct_price">
            <el-select v-model="targetWinType" class="jyd_select select_down target_select"
                       popper-class="custom-select-dropdown">
              <el-option v-for="item in targetWinTypes" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input class="direct_input" v-model="targetLimitWinPrice" v-if="targetWinType==2"/>
            <div class="target_price_market" v-if="targetWinType==1" style="background: #26282C;">
              <span class="new">{{ $t("market_order") }}</span>
            </div>
          </div>
        </div>

        <div class="order_price_box2" v-if="closeMarketType==2 && directValue==2">
          <div class="direct_price" style="margin-top: 7px">
            <span class="target_price_title">{{$t('stop_loss_trigger_price')}}</span>
            <el-input class="direct_input" v-model="targetLossPrice" style="margin-top: 6px;"/>
          </div>
          <div class="direct_price">
            <el-select v-model="targetLossType" class="jyd_select select_down target_select"
                       popper-class="custom-select-dropdown">
              <el-option v-for="item in targetLossTypes" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input class="direct_input" v-model="targetLimitLossPrice" v-if="targetLossType==2"/>
            <div class="target_price_market" v-if="targetLossType==1" style="background: #26282C;">
              <span class="new">{{ $t("market_order") }}</span>
            </div>
          </div>
        </div>


        <div class="ttt2">{{ $t("order_quantity") }}</div>
        <div class="order_price_box">
          <span class="ttt">{{ $t("order_quantity") }}</span>
          <el-input v-model="closeNum" :placeholder="$t('enter_content')" @focus="clear(2)"></el-input>
          <span :class="'new2 '" style="white-space: nowrap;cursor: pointer"
                @click="setCloseMax">|&nbsp;&nbsp;{{ $t("maximum_value") }}</span>
        </div>
        <draggable-progress v-model="progressClose" :content="['0','100%']"/>

        <div class="list" style="margin-top: 44px">
          <div class="left line"><span>{{ $t("max_close_long_short") }}</span></div>
          <div class="right line" :key="maxCloseCount">
            {{ getMaxCloseNum(1) }}/{{ getMaxCloseNum(2) }}
            <span
                style="margin-left: 10px;color:#A6A6A6">{{ closeValue }}</span></div>
        </div>
        <div :class="'list'" style="margin-top: 14px">
          <div class="left line">
            <span>{{ $t("close_long") }}</span>
            <span>{{ transBig2number(closeMarketLongAmount, 18, 4) }}</span>
          </div>
          <div class="right line">
            <span style="color: rgba(132, 142, 156, 1);border-bottom: revert;">{{ $t('close_short') }}</span>
            <span style="color:rgba(132, 142, 156, 1);border-bottom: revert;margin-left: 6px;"> {{
                transBig2number(closeMarketShortAmount, 18, 4)
              }}</span>
          </div>
        </div>
        <div class="btn_box">
          <div class="btnm" @click="open(2,true)" style="margin-right: 10px">
            {{ $t("close_long") }}
          </div>
          <div class="btnm" @click="open(2,false)" style="margin-left:10px;background: rgba(239, 69, 74, 1);">
            {{ $t('close_short') }}
          </div>
        </div>
      </div>
    </div>

    <el-dialog :modal="false" :title="this.tableData4[0].coin+'/'+(openType==1?this.openValue:closeValue)"
               :visible.sync="dialogVisible">
      <div class="dialog_title">
        <span class="more"
              v-if="this.isBuy">{{ openType == 1 ? $t('long_position') : ((this.closeMarketType == 2 ? ($t('take_profit_stop_loss')+"-") : "") + $t("close_long")) }}</span>
        <span
            v-if="!this.isBuy" class="less">{{
            openType == 1 ? $t("short_position") : ((this.closeMarketType == 2 ? ($t('take_profit_stop_loss')+"-") : "") + $t('close_short'))
          }}</span></div>
      <div>
        <div class="dialog_list" v-if="openType==1 || closeMarketType!=2">
          <div class="left">{{ $t("price") }}</div>
          <div class="right">
            <span v-if="openType==1 && openMarketType==0">{{this.openPrice}}</span>
            <span v-if="openType==2 && closeMarketType==0">{{this.closePrice}}</span>
            <span v-if="(openType==1 && openMarketType==1) || (openType==2 && closeMarketType==1)">{{$t('market_order')}}</span>
          </div>
        </div>
        <div class="dialog_list" v-if="openType==2 && closeMarketType==2">
          <div class="left">{{$t("type")}}</div>
          <div class="right">{{ this.directValue == 1 ? $t('one_side') : $t('both_sides') }}</div>
        </div>
        <div class="dialog_list" v-if="openType==2 && closeMarketType==2 && directValue==1">
          <div class="left">{{$t('trigger_price')}}</div>
          <div class="right">{{ this.targetPrice }}</div>
        </div>
        <div class="dialog_list" v-if="openType==2 && closeMarketType==2 && directValue==1">
          <div class="left">{{$t('limit_order2')}}/{{$t('market_order')}}</div>
          <div class="right">{{ targetType == 2 ? this.targetLimitPrice : $t('market_order') }}</div>
        </div>
        <div class="dialog_list" v-if="openType==2 && closeMarketType==2 && directValue==2">
          <div class="left">{{$t('take_profit_trigger_price')}}</div>
          <div class="right">{{ this.targetWinPrice }}</div>
        </div>
        <div class="dialog_list" v-if="openType==2 && closeMarketType==2 && directValue==2">
          <div class="left">{{$t('take_profit_limit')}}/{{$t('market_order')}}</div>
          <div class="right">{{ this.targetWinType == 2 ? this.targetWinPrice : $t('take_profit_market') }}</div>
        </div>
        <div class="dialog_list" v-if="openType==2 && closeMarketType==2 && directValue==2">
          <div class="left">{{$t('stop_loss_trigger_price')}}</div>
          <div class="right">{{ this.targetLossPrice }}</div>
        </div>
        <div class="dialog_list" v-if="openType==2 && closeMarketType==2 && directValue==2">
          <div class="left">{{$t('stop_loss_limit')}}/{{$t('market_order')}}</div>
          <div class="right">{{ this.targetLossType == 2 ? this.targetLossPrice : $t('stop_loss_market') }}</div>
        </div>

        <div class="dialog_list">
          <div class="left">{{ $t('quantity') }}</div>
          <div class="right">{{ this.openType == 1 ? openNum : (this.isBuy?transBig2number(closeMarketLongAmount):transBig2number(closeMarketShortAmount)) }}</div>
        </div>

        <div :class="'dialog_list'" v-if="openType==1">
          <div class="left">{{ $t("margin") }}</div>
          <div class="right">{{ this.openMarketType == 0 ? this.marginLimit : this.marginMarket }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="background: #C6FE61;color: #181A20" type="primary"
                   @click="ok1()">{{ $t("confirm") }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="levelVisible" :title="$t('adjust_leverage')" width="470px">
      <div class="level_content">
        <div class="level_title">{{ $t("leverage") }}</div>
        <div class="level">
          <div class="level_add" @click="addLevel(1)">-</div>
          <div class="level_num">{{ changeLevel }}x</div>
          <div class="level_sub" @click="addLevel(2)">+</div>
        </div>
        <draggable-progress v-model="changeLevel" :units="'x'" :content="['1x','25x','50x','75x','100x']"/>
        <div class="level_confirm" @click="doChangeLevel">{{ $t('confirm') }}</div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  createAndCall,
  createLeadingContractAndSend, createOrderBookAndCall,
  createPerpOptionAndCall, createTradeAndCall,
  createUnderlingAndCall, getAllTokenFromCache, getContractOrder,
  getErc20Info, getGasReward, getSelectTokenInfo, getValue
} from "../utils/contract";
import {ADDRESS_ZERO, Contract, Method, Underling} from "../config/const";
import {getLastPrice, registerService, removeService} from "../service/priceService";
import {transBig2number, transNumber2Big} from "../utils/functions";
import {ethers} from "ethers";
import config from "../config/config";
import {getChainId} from "../utils/wallet";

import DraggableProgress from '../components/DraggableProgress';
import scheduleContainer from '../components/scheduleContainer';
import {nextTick} from "vue";
import {BigNumber} from "ethers";
import {
  emmitMessage,
  emmitMessageDelayCount,
  emmitMessageWithDelay,
  MESSAGE,
  registerMessage,
  removeMessage
} from "../utils/message";

export default {
  name: "activate4_2",
  props: {
    contractAddress: "",
    token: "",
  },

  components: {
    DraggableProgress,
    scheduleContainer
  },
  computed: {},
  data() {
    return {
      progressValue: 0,
      progressValue2: 29,
      isDragging: false,
      isDragging2: false,
      levelVisible: false,
      sliderWidth: 0,
      sliderWidth2: 0,
      handleLeft: 0,
      handleLeft2: 0,
      containerWidth: 300, // Width of the slider container
      containerWidth2: 300, // Width of the slider container
      tableData4: [
        {
          order: '',
          deal: '',
          coin: '',
          type: 1,
          open: 0,
          price: '',
          price2: '',
          pan: '',
          nextTime: '',
          timePrice: 0,
          operate: 0
        },
      ],
      currentPage: 1,
      leftBL: '20%',
      input: '121212',
      openValue: 'BTC',
      closeValue: "BTC",
      options: [
        {
          value: 'BTC',
          label: 'BTC'
        },
        {
          value: 'ETH',
          label: 'ETH'
        },
        {
          value: 'SOL',
          label: 'SOL'
        },
      ],
      directValues: [
        {
          value: 1,
          label: this.$t('one_side')
        },
        {
          value: 2,
          label: this.$t('both_sides')
        },
      ],
      targetTypes: [
        {
          value: 1,
          label: this.$t('market_order2')
        },
        {
          value: 2,
          label: this.$t('limit_order2')
        }
      ],
      targetType: 1,
      directValue: 1,

      targetWinTypes: [
        {
          value: 1,
          label: this.$t('take_profit_market')
        },
        {
          value: 2,
          label: this.$t('limit_take_profit')
        }
      ],
      targetWinType: 1,

      targetLossTypes: [
        {
          value: 1,
          label: this.$t('stop_loss_market')
        },
        {
          value: 2,
          label: "限价止损"
        }
      ],
      targetLossType: 1,

      targetLimitPrice: "",
      currentPrice: "0",
      maxOpen: 0,
      maxMarket: 0,
      estimateLimit: 0,
      estimateMarket: 0,
      foundFeeLimit: 0,
      foundFeeMarket: 0,
      dialogVisible: false,
      openType: 1,  // 1开仓 2 平仓
      isBuy: true,
      isOpen: true,
      loading: false,
      showModal: false,
      openPriceArr: [],
      closePriceArr: [],
      currentOpenPrice: 0,
      decimals: 18,
      viewInit: false,
      levelClose: 100,
      levelOpen: 100,
      levelETH: 100,
      levelBTC: 100,
      levelSOL: 100,
      levelMap: {},
      changeLevel: 100,
      changeLevelType: 1,
      optionAddress: "",
      marginLimit: "0",
      marginMarket: "0",
      maxLongBTC: BigNumber.from(0),
      maxLongETH: BigNumber.from(0),
      maxShortBTC: BigNumber.from(0),
      maxShortETH: BigNumber.from(0),
      maxLongSOL: BigNumber.from(0),
      maxShortSOL: BigNumber.from(0),
      closeLimitLongAmount: BigNumber.from(0),
      closeLimitShortAmount: BigNumber.from(0),
      closeMarketLongAmount: BigNumber.from(0),
      closeMarketShortAmount: BigNumber.from(0),
      progressOpen: 0,
      progressClose: 0,
      openMarketType: 0, //0 限价 1市价
      closeMarketType: 0, //0 限价 1 市价 2 止盈止损
      targetPrice: "",
      openNum: 0,
      closeNum: 0,
      closePrice: "",
      openPrice: "",
      targetWinPrice: "",
      targetLimitWinPrice: "",
      targetLossPrice: "",
      targetLimitLossPrice: "",
      positionCache: undefined,
      maxCloseCount:0

    }
  },
  mounted() {
    registerService( this.updatePrice)
    registerMessage(this.receiveMsg)
  },
  unmounted() {
    removeService(this.updatePrice)
    removeMessage(this.receiveMsg)
  },
  methods: {
    transBig2number,

    setStop(isStop) {
      this.viewInit = isStop;
    },

    async updateLimitPrice(type) {
      let priceData = await getLastPrice();
      if (type == 1) {
        let currPrice = transBig2number(priceData[this.openValue].price, priceData[this.openValue].decimal);
        this.openPrice = currPrice;
      } else if (type == 2) {
        let currPrice = transBig2number(priceData[this.closeValue].price, priceData[this.closeValue].decimal);
        this.closePrice = currPrice;
      }
    },
    async clear(type) {
      if (type == 1) {
        this.progressOpen = 0
        await nextTick()
        this.openNum = ""
      } else {
        this.progressClose = 0
        await nextTick()
        this.closeNum = ""
      }

    },
    async getDataInfo() {
      if (!this.contractAddress) {
        return;
      }
      if (!this.token) {
        return;
      }

      let tokenInfo = await getSelectTokenInfo(this.token);
      if (!tokenInfo) {
        return;
      }
      this.optionAddress = tokenInfo.perpetual;
      if (!this.optionAddress) {
        return;
      }

      let tokenSymbols = await getErc20Info([this.token]);
      let tokenDecimals = await getErc20Info([this.token], Method.decimals)
      this.decimals = tokenDecimals[0];
      this.tableData4[0].coin = tokenSymbols[0];

      this.tableData4[0].order = this.token;

      let accountInfo = await createPerpOptionAndCall(this.optionAddress, Method.getAccountInfo, this.token, this.contractAddress);

      if (accountInfo) {
        this.tableData4[0].price = transBig2number(accountInfo.depositAmount);
        this.tableData4[0].price2 = transBig2number(accountInfo.availableAmount);
        this.tableData4[0].price3 = transBig2number(accountInfo.lockedAmount);
      }
    },
    setOpenMax() {
      this.openNum = this.maxOpen
    },
    setCloseMax() {
      this.closeNum = this.maxMarket;
    },
    async getPositions() {
      if (!this.contractAddress) {
        return;
      }
      let selectToken = await getSelectTokenInfo(this.token);
      let orders = await getContractOrder(this.token, this.contractAddress, selectToken.orderBook);
      this.positionCache = orders;

      let orderIds = await createOrderBookAndCall(selectToken.orderBook, Method.getUserLimitOrdersID, this.token, this.contractAddress)
      let limitOrder = await createTradeAndCall(selectToken.tradeAgent, Method.getLimitOrders, orderIds)

      let maxLongBTC = orders["BTC_1"].size;
      let maxShortBTC = orders["BTC_2"].size;
      let maxLongETH = orders["ETH_1"].size;
      let maxShortETH = orders["ETH_2"].size;
      let maxLongSOL=orders["SOL_1"].size;
      let maxShortSOL=orders["SOL_2"].size;

      for (let i in limitOrder) {
        let item = limitOrder[i];
        if (item.offset === 1) {
          continue;
        }
        if (item.name == "BTC" && item.direct == 1) {
          maxLongBTC = maxLongBTC.sub(item.amount)
        } else if (item.name == "BTC" && item.direct == 2) {
          maxShortBTC = maxShortBTC.sub(item.amount)
        } else if (item.name == "ETH" && item.direct == 1) {
          maxLongETH = maxLongETH.sub(item.amount)
        } else if (item.name == "ETH" && item.direct == 2) {
          maxShortETH = maxShortETH.sub(item.amount)
        } else if(item.name=="SOL" && item.direct==1){
          maxLongSOL=maxLongSOL.sub(item.amount)
        } else if(item.name=="SOL" && item.direct==2){
          maxShortSOL=maxShortSOL.sub(item.amount)
        }
      }
      this.maxLongBTC = maxLongBTC
      this.maxShortBTC = maxShortBTC
      this.maxLongETH = maxLongETH
      this.maxShortETH = maxShortETH
      this.maxLongSOL=maxLongSOL
      this.maxShortSOL=maxShortSOL

      console.log("max data is", this.maxLongBTC, this.maxLongETH,this.maxLongSOL,this.maxShortSOL);

    },
    getMaxCloseNum(type) { // type 1 开仓最大数量 2 平仓最大数量
      if (type == 1) {
        if (this.closeValue == "BTC") {
          return transBig2number(this.maxLongBTC, 18, 4)
        } else if (this.closeValue == "ETH") {
          return transBig2number(this.maxLongETH, 18, 4)
        } else if (this.closeValue == "SOL") {
          return transBig2number(this.maxLongSOL, 18, 4)
        }
      } else if (type == 2) {
        if (this.closeValue == "BTC") {
          return transBig2number(this.maxShortBTC, 18, 4)
        } else if (this.closeValue == "ETH") {
          return transBig2number(this.maxShortETH, 18, 4)
        } else if (this.closeValue == "SOL") {
          return transBig2number(this.maxShortSOL, 18, 4)
        }
      }

    },
    updatePrice(priceData) {
      if (!priceData) {
        return;
      }
      if (!this.viewInit) {
        return;
      }
      if (!priceData[this.closeValue] || !priceData[this.openValue]) {
        return;
      }
      let currPrice = transBig2number(priceData[this.closeValue].price, priceData[this.closeValue].decimal);
      this.currentPrice = currPrice;

      let currLimitPrice = transBig2number(priceData[this.openValue].price, priceData[this.openValue].decimal);
      this.currentOpenPrice = currLimitPrice;

      if (this.openPrice === "") {
        this.openPrice = currPrice;
      }
      if (this.closePrice == "") {
        this.closePrice = currPrice;
      }
    },
    async getmaxOpenAmount() {
      let selectToken = await getSelectTokenInfo(this.token)
      let max = await createTradeAndCall(selectToken.tradeAgent, Method.getMaxAmount, this.token, this.contractAddress, this.openValue, transNumber2Big(this.openPrice));
      console.log("get max is", this.openValue, max.toString());
      this.maxOpen = transBig2number(max, 18, 8, true);
    },
    async getMaxMarketAmount() {
      let selectToken = await getSelectTokenInfo(this.token)
      let max = await createTradeAndCall(selectToken.tradeAgent, Method.getMaxAmount, this.token, this.contractAddress, this.closeValue, transNumber2Big(this.currentOpenPrice));
      this.maxMarket = transBig2number(max, 18, 8, true);
    },


    async estimateLimitFee() {

      this.estimateMargin(1)
    },
    async estimateMarketFee() {

      this.estimateMargin(2)
    },

    /**
     * @param isBuy 多或空 true 多 false 空
     * @param isLimit 是否限价 true 是 false 否
     * @param offset 1 开仓 2平仓
     * */
    async trade(isBuy, isLimit, offset) {
      /**
       * 初始化参数
       * */
      let num = BigNumber.from(0);
      let value = "BTC";
      let price = BigNumber.from(0);

      if (offset == 1) {
        num = BigNumber.from(transNumber2Big(this.openNum));
      } else {
        num = isBuy?this.closeMarketLongAmount:this.closeMarketShortAmount;
      }
      if (offset == 1) {
        value = this.openValue;
      } else {
        value = this.closeValue;
      }
      let orderType2 = 0;

      if (isLimit) {
        if (offset == 1) {
          price = transNumber2Big(this.openPrice)
        } else {
          price = transNumber2Big(this.closePrice)
        }
      } else {
        let prices = await getLastPrice();
        let priceData;
        if(offset==1){
          priceData = transBig2number(prices[this.openValue].price, prices[this.openValue].decimal);
        }else{
          priceData = transBig2number(prices[this.closeValue].price, prices[this.closeValue].decimal);
        }

        if (offset == 1 && isBuy) {
          price = BigNumber.from(transNumber2Big(priceData)).mul(BigNumber.from(105)).div(BigNumber.from(100));
        } else if (offset == 1 && !isBuy) {
          price = 1;
        } else if (offset == 2 && isBuy) {
          orderType2 = 21;
          price = BigNumber.from(transNumber2Big(priceData)).mul(BigNumber.from(90)).div(BigNumber.from(100));
        } else if (offset == 2 && !isBuy) {
          orderType2 = 21;
          price = BigNumber.from(transNumber2Big(priceData)).mul(BigNumber.from(110)).div(BigNumber.from(100));
        }
      }


      if (num.lte(BigNumber.from(0))) {
        await this.$message.error(this.$t("quantityMustBePositive"))
        return;
      }
      this.$store.commit('setLoading', true)
      setTimeout(() => {
        this.$store.commit('setLoading', false)
      }, 30000)

      let tigger = await getGasReward(this.token, this.openValue);

      const tx = await createLeadingContractAndSend(
          this.contractAddress, Method.trade,
          [
            value,
            num.toString(),
            price.toString(),
            1,
            offset,
            isBuy ? 1 : 2,
            orderType2,
            parseInt(new Date().getTime() / 1000) + 31536000,
            ethers.utils.arrayify("0x"),
          ], tigger);

      emmitMessageDelayCount({msg: MESSAGE.POSITION_UPDATE, delay: 5000,count:20})

      if (tx) {
        this.$store.commit('setLoading', false)
        this.$emit("refresh-data");
        this.init()
      }

    },

    async otcTrade(isBuy) {//otc 平仓


      //设定参数
      let name = this.closeValue;
      let amount = isBuy?this.closeMarketLongAmount:this.closeMarketShortAmount;
      let offset = 2;
      let direct = isBuy ? 1 : 2
      let param1 = "0";
      let param2 = "0";
      let param3 = "0";
      let param4 = "0";

      if (!this.positionCache) {
        this.$message.error(this.$t('data_return_incorrect'));
        return;
      }

      if (this.directValue == 1) { // 1单向 2双向
        let targetPriceBig = transNumber2Big(this.targetPrice)

        if(isBuy && parseFloat(this.targetPrice) >= this.positionCache[this.closeValue + "_1"].price){
          param1 = targetPriceBig;
          if (this.targetType == 2) { // 1 市价止盈，2限价止盈
            param2 = transNumber2Big(this.targetLimitPrice)
          }
        }else if(isBuy &&  parseFloat(this.targetPrice) < this.positionCache[this.closeValue + "_2"].price){
          param3=targetPriceBig;
          if (this.targetType == 2) { // 1 市价止盈，2限价止盈
            param4 = transNumber2Big(this.targetLimitPrice)
          }
        }else if(!isBuy && parseFloat(this.targetPrice) <= this.positionCache[this.closeValue + "_1"].price){
          param1 = targetPriceBig;
          if (this.targetType == 2) { // 1 市价止盈，2限价止盈
            param2 = transNumber2Big(this.targetLimitPrice)
          }
        }else if(!isBuy && parseFloat(this.targetPrice) > this.positionCache[this.closeValue + "_2"].price){
          param3=targetPriceBig;
          if (this.targetType == 2) { // 1 市价止盈，2限价止盈
            param4 = transNumber2Big(this.targetLimitPrice)
          }
        }


      } else if (this.directValue == 2) {

        if (!this.targetWinPrice) {
          this.$message.error(this.$t('tp_price_must_gt_zero'))
          return;
        }
        if (!this.targetLossPrice) {
          this.$message.error(this.$t('sl_price_must_gt_zero'))
          return;
        }

        console.log("direct value 2", isBuy, this.targetWinPrice, this.targetLossPrice, this.positionCache[this.closeValue + "_1"].price, this.positionCache[this.closeValue + "_2"].price);
        if (isBuy && parseFloat(this.targetWinPrice) <= this.positionCache[this.closeValue + "_1"].price) {
          this.$message.error(this.$t('long_tp_should_gt_cost'))
          return;
        }
        if (isBuy && parseFloat(this.targetLossPrice) >= this.positionCache[this.closeValue + "_1"].price) {
          this.$message.error(this.$t('long_sl_should_lt_cost'))
          return;
        }
        if (!isBuy && parseFloat(this.targetWinPrice) >= this.positionCache[this.closeValue + "_2"].price) {
          this.$message.error(this.$t('short_tp_should_lt_cost'))
          return;
        }
        if (!isBuy && parseFloat(this.targetLossPrice) <= this.positionCache[this.closeValue + "_2"].price) {
          this.$message.error(this.$t('short_sl_should_gt_cost'))
          return;
        }

        param1 = transNumber2Big(this.targetWinPrice)
        param3 = transNumber2Big(this.targetLossPrice)

        if (this.targetWinType == 2) {
          if (!this.targetLimitWinPrice) {
            this.$message.error(this.$t('tp_limit_cannot_empty'));
            return;
          }
          param2 = transNumber2Big(this.targetLimitWinPrice)
        }

        if (this.targetLossType == 2) {
          if (!this.targetLimitLossPrice) {
            this.$message.error(this.$t('sl_limit_cannot_empty'));
            return;
          }
          param4 = transNumber2Big(this.targetLimitLossPrice)
        }

      }

      this.$store.commit('setLoading', true)
      setTimeout(() => {
        this.$store.commit('setLoading', false)
      }, 30000)


      try {
        let tigger = await getGasReward(this.token, this.closeValue);
        let tx = await createLeadingContractAndSend(this.contractAddress, Method.ocoTrade, [
          name,
          amount.toString(),
          offset,
          direct,
          param1,
          param2,
          param3,
          param4,
          parseInt(new Date().getTime() / 1000) + 31536000
        ], BigNumber.from(tigger).mul(BigNumber.from(2)).toString())
        console.log("trans ok", tx);
        emmitMessageDelayCount({msg: MESSAGE.POSITION_UPDATE, delay: 5000,count:20})
      } catch (e) {
        this.$store.commit('setLoading', false)
        console.log("error is", e);
      }


    },

    /**
     * @param openType 1 开仓 2平仓
     * @param isBuy true 做多 false 做空
     * */
    open(openType, isBuy) {
      this.openType = openType
      this.isBuy = isBuy
      if (openType == 1) {
        if (this.openNum <= 0) {
          this.$message.error(this.$t("quantityMustBePositive"))
          return;
        }
      } else {
        if (this.closeNum <= 0) {
          this.$message.error(this.$t("quantityMustBePositive"))
          return;
        }

      }
      this.dialogVisible = true
    },
    ok1() {
      this.dialogVisible = false

      if (this.openType == 1) {
        this.trade(this.isBuy, this.openMarketType == 0, this.openType)
      } else if (this.openType == 2 && this.closeMarketType != 2) {
        this.trade(this.isBuy, this.closeMarketType == 0, this.openType)
      } else if (this.openType == 2 && this.closeMarketType == 2) {
        this.otcTrade(this.isBuy);
      }

    },
    async init() {
      console.log("init", 42);
      this.loading = true
      await this.getDataInfo()
      this.loading = false
    },

    openModal() {
      this.showModal = !this.showModal;
    },
    closeModal() {
      this.showModal = false;
    },
    add(type, num) {
      if (type == 1) {
        this.openPriceArr.push(parseFloat(this.openPrice))
        this.openPrice = parseFloat(this.openPrice) + num;
      } else {
        this.closePriceArr.push(parseFloat(this.closePrice))
        this.closePrice = parseFloat(this.closePrice) + num;
      }

    },
    returnPrice(type) {
      if (type == 1) {
        this.openPrice = this.openPriceArr.pop();
      } else {
        this.closePrice = this.closePriceArr.pop();
      }
    },
    clearPrice(type) {
      if (type == 1) {
        this.openPrice = 0;
      } else {
        this.closePrice = 0;
      }
    },
    async estimateMargin(type) {
      let price = await getLastPrice()
      //限价
      if (type == 1) {
        this.marginLimit = (parseFloat(this.openPrice) * Number(this.openNum) / this.levelOpen).toFixed(2);
      } else {
        this.marginMarket = (parseFloat(transBig2number(price[this.openValue].price, price[this.openValue].decimal)) * Number(this.openNum) / this.levelOpen).toFixed(2);
      }
    },
    async getLevelInfo() {
      let selectInfo = await getSelectTokenInfo(this.token)
      this.optionAddress = selectInfo.perpetual;
      if (!this.optionAddress) {
        return;
      }
      let levelBTC = await createPerpOptionAndCall(this.optionAddress, Method.getUserLeverage, this.token, this.contractAddress, "BTC");
      let levelETH = await createPerpOptionAndCall(this.optionAddress, Method.getUserLeverage, this.token, this.contractAddress, "ETH");
      let levelSOL = await createPerpOptionAndCall(this.optionAddress, Method.getUserLeverage, this.token, this.contractAddress, "SOL");
      this.levelBTC = parseInt(levelBTC.toString())
      this.levelETH = parseInt(levelETH.toString())
      this.levelSOL = parseInt(levelSOL.toString())

      this.levelMap = {
        BTC: this.levelBTC,
        ETH: this.levelETH,
        SOL: this.levelSOL
      }
      this.levelOpen = this.levelMap[this.openValue]
      this.levelClose = this.levelMap[this.closeValue]

    },
    openLevel(type) {
      this.changeLevel = type == 1 ? this.levelOpen : this.levelClose;
      this.levelVisible = true;
      this.changeLevelType = type;
    },
    async doChangeLevel() {
      let changeType = "";
      this.levelVisible = false;
      if (this.changeLevelType == 1) {
        changeType = this.openValue;
      } else {
        changeType = this.closeValue
      }
      if (!this.optionAddress || !changeType) {
        return;
      }
      await createLeadingContractAndSend(this.contractAddress, Method.setUserLeverage, [changeType, this.changeLevel], 0)
      this.getLevelInfo()
    },
    addLevel(type) {
      console.log("type =", type);
      if (type == 2) {
        if (this.changeLevel < 100) {
          this.changeLevel++;
        }
      } else if (type == 1) {
        if (this.changeLevel > 0) {
          this.changeLevel--;
        }
      }
    },
    async receiveMsg(msg, data) {
      if (msg == MESSAGE.POSITION_UPDATE) {
        await this.getPositions()
        this.maxCloseCount++
        console.log("max close count is",this.maxCloseCount,this.getMaxCloseNum(1),this.getMaxCloseNum(2));
      }
    }
  },
  directives: {
    'click-outside': {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // 检查点击是否发生在元素外部
          if (!(el === event.target || el.contains(event.target))) {
            // 调用绑定的方法
            vnode.context[binding.expression](event);
          }
        };
        // 添加事件监听
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) {
        // 移除事件监听
        document.body.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  },
  watch: {
    openPrice(val1, val2) {
      if (this.viewInit) {
        this.getmaxOpenAmount();
        this.estimateLimitFee();
      }
    },
    currentPrice(val1, val2) {
      if (this.viewInit) {
        this.getMaxMarketAmount();
        this.estimateMarketFee();
      }
    },
    openNum(val) {
      this.estimateLimitFee();
      if (!isNaN(Number(val))) {
        let closeBig = BigNumber.from(transNumber2Big(val));
        if (this.openValue == "BTC") {
          this.closeLimitLongAmount = closeBig.gt(this.maxLongBTC) ? this.maxLongBTC : closeBig;
          this.closeLimitShortAmount = closeBig.gt(this.maxShortBTC) ? this.maxShortBTC : closeBig;
        } else {
          this.closeLimitLongAmount = closeBig.gt(this.maxLongETH) ? this.maxLongETH : closeBig;
          this.closeLimitShortAmount = closeBig.gt(this.maxShortETH) ? this.maxShortETH : closeBig;
        }
      }
    },
    closeNum(val) {
      this.estimateMarketFee();
      if (!isNaN(Number(val))) {
        let closeBig = BigNumber.from(transNumber2Big(val));
        if (this.closeValue == "BTC") {
          this.closeMarketLongAmount = closeBig.gt(this.maxLongBTC) ? this.maxLongBTC : closeBig;
          this.closeMarketShortAmount = closeBig.gt(this.maxShortBTC) ? this.maxShortBTC : closeBig;
        } else if (this.closeValue == "ETH") {
          this.closeMarketLongAmount = closeBig.gt(this.maxLongETH) ? this.maxLongETH : closeBig;
          this.closeMarketShortAmount = closeBig.gt(this.maxShortETH) ? this.maxShortETH : closeBig;
        } else {
          this.closeMarketLongAmount = closeBig.gt(this.maxLongSOL) ? this.maxLongSOL : closeBig;
          this.closeMarketShortAmount = closeBig.gt(this.maxShortSOL) ? this.maxShortSOL : closeBig;
        }
      }

    },
    async openValue(val1) {

      let priceData = await getLastPrice();
      let currLimitPrice = transBig2number(priceData[this.openValue].price, priceData[this.openValue].decimal);
      this.openPrice = currLimitPrice;
      this.currentOpenPrice=currLimitPrice;

      this.getmaxOpenAmount();
      this.estimateLimitFee();
      this.limitNum = 0;
      this.estimateLimit = 0;
      this.foundFeeLimit = 0;
      this.maxOpen = 0;

      this.levelOpen = this.levelMap[val1];

      this.closeLimitLongAmount = BigNumber.from(0)
      this.closeLimitShortAmount = BigNumber.from(0)

      this.progressOpen = 0;

    },
    async closeValue(val) {

      let priceData = await getLastPrice();
      let currPrice = transBig2number(priceData[this.closeValue].price, priceData[this.closeValue].decimal);
      this.currentPrice = currPrice;
      this.closePrice=currPrice;

      this.getMaxMarketAmount();
      this.estimateMarketFee();
      this.closeNum = 0;
      this.estimateMarket = 0;
      this.foundFeeMarket = 0;
      this.maxMarket = 0;


      this.levelClose = this.levelMap[val];

      this.closeMarketLongAmount = BigNumber.from(0)
      this.closeMarketShortAmount = BigNumber.from(0)
      this.progressClose = 0;
    },
    progressOpen(newVal) {
      if (parseFloat(this.maxOpen) === 0) {
        return;
      }
      let openNum = this.maxOpen * newVal / 100;
      if (Math.abs(this.openNum - openNum) > this.maxOpen * 0.01) {
        this.openNum = parseFloat(openNum.toFixed(4));
      }
    },
    progressClose(newVal) {

      this.closeNum = newVal + "%";
      if (this.closeValue == "BTC") {
        this.closeMarketLongAmount = this.maxLongBTC.mul(BigNumber.from(newVal)).div(100);
        this.closeMarketShortAmount = this.maxShortBTC.mul(BigNumber.from(newVal)).div(100);
      } else if(this.closeValue=="ETH"){
        this.closeMarketLongAmount = this.maxLongETH.mul(BigNumber.from(newVal)).div(100);
        this.closeMarketShortAmount = this.maxShortETH.mul(BigNumber.from(newVal)).div(100);
      }else {
        this.closeMarketLongAmount = this.maxLongSOL.mul(BigNumber.from(newVal)).div(100);
        this.closeMarketShortAmount = this.maxShortSOL.mul(BigNumber.from(newVal)).div(100);
      }

    },



  },

  created() {
    this.getDataInfo()
    this.getLevelInfo()
    this.getPositions()
  }
}
</script>
<style src="../assets/css/celect.css"></style>
<style src="../assets/list.scss" lang="scss" scoped></style>
<style src="../assets/windows.scss" lang="scss" scoped></style>
<style src="../assets/css/index.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.el-input__inner {
  color: #A6A6A6 !important;
}

.willHide {
  display: none !important;
}

.level_title {
  color: white;
}

.level {
  display: flex;
  border-radius: 8px;
  border: 1px solid rgba(128, 128, 128, 1);
  height: 40px;
  padding-left: 15px;
  padding-right: 15px;
  color: rgba(128, 128, 128, 1);
  align-items: center;
  font-size: 14px;
  margin-top: 20px;
}

.level_num {
  flex: 1;
  text-align: center;
}

.level_add, .level_sub {
  font-size: 20px;
  cursor: pointer;
}

.level_confirm {
  width: 100%;
  height: 44px;
  margin-top: 40px;
  margin-left: auto;
  border-radius: 8px;
  margin-right: auto;
  border: 1px solid rgba(198, 254, 97, 1);
  background: rgba(198, 254, 97, 1);
  font-size: 15px;
  font-weight: 500;
  color: black;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}

.title_box {
  display: flex;
  gap: 24px;
  margin-bottom: 30px;
  margin-left: -12px;

  .contract_type {
    width: 96px;
    height: 32px;
    border-radius: 8px;
    background: rgba(38, 40, 44, 1);
    font-size: 15px;
    color: rgba(234, 236, 239, 1);
    font-family: "思源黑体";
    text-align: center;
    line-height: 32px;
  }

  .contract_level {
    width: 96px;
    height: 32px;
    border-radius: 8px;
    background: rgba(69, 73, 82, 1);
    font-size: 15px;
    color: rgba(234, 236, 239, 1);
    font-family: "思源黑体";
    text-align: center;
    line-height: 32px;
    cursor: pointer;
  }
}

.openC {
  border-radius: 6px;
  height: 26px;
  margin-top: 19px;
  position: relative;
  margin-bottom: 20px;

  .openItem {
    width: 50%;

    .openItemTitle {
      text-align: center;
      display: inline-block;
      line-height: 26px;
      font-size: 12px;
      font-weight: 700;
      width: 100%;
      cursor: pointer;
      color: #202630;

      &.active {
        background: rgba(174, 177, 184, 1);
      }

      &.darkMode {
        color: #FFFFFFFF;

        &.active {
          background: #474D57FF;
        }
      }

    }
  }

  .openItemBox {
    height: 20px;
    width: 20px;
    margin-left: -10px;
    position: absolute;
    margin-top: 4px;
    display: inline-block;
    transform: rotate(45deg);
    border-radius: 4px;
    background: rgba(174, 177, 184, 1);

    &.darkMode {
      background: #474D57FF;
    }
  }

  .open {
    float: left;

    .openTitle {
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
      border-left: 1.3px solid #AEB1B8;
      border-top: 1.3px solid #AEB1B8;
      border-bottom: 1.3px solid #AEB1B8;

      &.darkMode {
        border-left: 1.3px solid #808080FF;
        border-top: 1.3px solid #808080FF;
        border-bottom: 1.3px solid #808080FF;

        &.active {
          border-color: #474D57;
        }
      }

      border-right: 0 none;
    }
  }

  .close {
    float: right;

    .closeTitle {
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;

      border-right: 1.3px solid #AEB1B8;
      border-top: 1.3px solid #AEB1B8;
      border-bottom: 1.3px solid #AEB1B8;

      &.darkMode {
        border-right: 1.3px solid #808080FF;
        border-top: 1.3px solid #808080FF;
        border-bottom: 1.3px solid #808080FF;

        &.active {
          border-color: #474D57;
        }
      }

      border-left: 0 none;
    }

  }
}

.list_box {
  margin-top: 30px;

  .titile {
    color: rgba(174, 177, 184, 1);
    font-size: 16px;
    font-weight: 700;
    height: 32px;
    white-space: nowrap;
    border-bottom: 1px solid rgba(234, 236, 239, 0.2);
    display: flex;

    .t_item {
      cursor: pointer;
      position: relative;

      &.active::after {
        content: "";
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0px;
        width: 32px;
        height: 2px;
        background: rgba(198, 254, 97, 1);
      }
    }
  }

  .top_box {
    margin-top: 24px;

    .jyd {


      .jyd_select {
        width: 118px;
      }

      span {
        font-size: 15px;
        font-weight: 500;
        color: #EAECEF;
        margin-right: 10px;
      }
    }

    .price {
      font-weight: 500;
      width: 150px;
      text-align: right;
      min-width: 150px;

      span {
        color: rgba(132, 142, 156, 1);
      }
    }

    .list {
      .left {
        position: relative;
      }
    }
  }
}

.order_price_box2 {
  display: flex;
  //margin-top: 18px;
  gap: 8px;

  .direct_price {
    flex: 1;
  }

  .target_price_title {
    font-size: 15px;
    font-weight: 500;
    letter-spacing: -0.2px;
    line-height: 17.65px;
    color: rgba(166, 166, 166, 1);
  }

  .direct_input {
    text-align: left;
    //margin-top: 6px;
    border-radius: 8px;
    height: 34px;
    line-height: 34px;
    background: rgba(24, 26, 32, 1);
    border: 1px solid rgba(234, 236, 239, 0.2);
    margin-right: 8px;
  }

  .target_price_market {
    height: 36px;
    opacity: 1;
    border-radius: 8px;
    background: rgba(38, 40, 44, 1);
    line-height: 36px;
    padding-left: 18px;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0px;
    color: rgba(166, 166, 166, 1);
    font-family: Gilroy;

  }
}

::v-deep .direct_input .el-input__inner {
  text-align: left;
  color: white;
}

.order_price_box {
  color: #A6A6A6;
  position: relative;

  .grid_box {
    display: flex;
    position: absolute;
    background-color: #17191b;
    box-shadow: 0px 10px 25px #000000 !important;
    width: 200px;
    flex-wrap: wrap;
    z-index: 999999;
    border-radius: 10px;
    right: 0;
    top: 40px;

    .grid_list {
      width: calc(50% - 1px);
      font-size: 14px;
      border-bottom: 1px solid #A6A6A6;
      color: #A6A6A6;
      text-align: center;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        width: 20px;
      }
    }

    .grid_list:nth-child(odd) {
      border-right: 1px solid #A6A6A6;
    }
  }
}

.activate4_box .list_box .list .left span {
  color: #A6A6A6;
}


.slider-container {
  width: 100%;
  height: 3px;
  background-color: #ccc;
  position: relative;
  margin-top: 30px;

  .ct_box {
    position: absolute;
    z-index: 1;
    width: 100%;
    margin-top: -5px;

    .aaa {
      width: 12px;
      height: 12px;
      margin-right: calc(25% - 15px);
    }

    img {
      width: 12px;
      height: 12px;
      min-width: 12px;
      min-height: 12px;
    }
  }
}

.slider-bar {
  height: 100%;
  width: 0;
  /* This will be updated dynamically */
  background-color: #C6FE61;
  position: absolute;
  left: 0;
  top: 0;
}

.slider-handle {
  width: 30px;
  height: 30px;
  border: 1px solid #ccc;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  /* This will be updated dynamically */
  cursor: pointer;
  z-index: 10;
  background-color: #181A20;
}

::v-deep .el-dialog__footer {
  padding: 0px 24px 22px !important;
}

::v-deep .el-dialog {
  width: 380px !important;
}

@media (max-width: 750px) {
  ::v-deep .el-dialog {
    width: 80% !important;
  }
}

.direct_title {
  font-size: 15px;
  font-weight: 500;
  letter-spacing: -0.2px;
  line-height: 17.65px;
  color: rgba(234, 236, 239, 1);
  font-family: Gilroy;
}

.direct_select {
  width: 120px;
  border-radius: 8px;
  background: rgba(38, 40, 44, 1);
  margin-left: 8px;
}

.target_select {
  width: 100px;
}
</style>
<style>
.el-table,
.el-table__expanded-cell {
  background-color: rgba(24, 26, 32, 1);
}
</style>
<style scoped lang="scss">
.select_down {
  ::v-deep .el-input__suffix {
    .el-input__suffix-inner {
      .el-select__caret {
        font-family: 'element-icons' !important; // 确保使用 Element UI 的字体

        &.el-icon-arrow-up::before {
          content: "\e78f"; // 替换为你想用的 Element UI 图标的 Unicode 编码
        }

        &.el-icon-arrow-down::before {
          content: "\e790"; // 和展开时使用同一个图标的 Unicode
        }
      }
    }
  }
}
</style>